<template>
  <b-modal
    id="page-attendance-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :cancel-title="trans('cancel')"
    size="xl"
    no-enforce-focus
    @shown="onShown"
    @hidden="onHidden"
    @ok="onSave"
  >
    <template #modal-title>
      <i class="fa fa-clipboard-list"></i>
      <span>{{ trans('attendance_list') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>

    <b-row>
      <b-col class="col-5">
        <b-form-group :label="trans('header')">
          <html-textarea
            :organization="organization"
            v-model="text"
            for-microsite
            show-insert-form-document
            :placeholders="placeholders"
          ></html-textarea>
        </b-form-group>
        <hr/>

        <b-form-group v-if="visible" :label="trans('class_event')">
          <class-dropdown
            :organization="organization"
            v-model="am_class_id"
            :placeholder="trans('choose_a_class_event')"
            size="sm"
            :disabled="busy"
            @cls="onChooseClass($event)"
          ></class-dropdown>
        </b-form-group>

        <b-form-group :label="trans('width')">
          <b-form-radio-group v-model="image_percent" :options="image_percent_options" />
        </b-form-group>
        <b-form-group :label="trans('position')">
          <b-form-radio-group v-model="span_row">
            <b-form-radio :value="false">
              {{ trans('inline') }}
            </b-form-radio>
            <b-form-radio :value="true">
              {{ trans('span_row') }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="span_row" :label="trans('align')">
          <b-form-radio-group v-model="h_align" :options="hAlignOptions"></b-form-radio-group>
        </b-form-group>
        <hr/>

        <b-form-group :label="trans('footer')">
          <html-textarea
            :organization="organization"
            v-model="text2"
            for-microsite
            show-insert-form-document
            :placeholders="placeholders"
          ></html-textarea>
        </b-form-group>
      </b-col>
      <b-col class="col-7">
        <page-attendance-block
          v-if="visible"
          :organization="organization"
          :page="page"
          :block="serializedForPreview"
          is-preview
        ></page-attendance-block>
      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import PageAttendanceBlock from './PageAttendanceBlock'
  import ClassDropdown from './../class/ClassDropdown'

  let defaultText = `<h4 style="text-align:center;"><span class="placeholder">{${trans('class')}}</span></h4><p style="text-align:center;"><span class="placeholder">{${lang == 'fr' ? 'Date/heure de début' : 'Start date/time'}}</span></p>`

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
      type: {
        type: String,
        default: 'attendance',
      },
    },
    components: {
      HtmlTextarea,
      PageAttendanceBlock,
      ClassDropdown,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        lang: window.lang,
        error: null,
        visible: false,
        placeholders: _.getClassEventPlaceholders(),
        text: defaultText,
        text2: null,
        image_percent: 0.3333,
        image_percent_options: [
          {text: '25%', value: 0.25},
          {text: '33%', value: 0.3333},
          {text: '50%', value: 0.5},
          {text: '66%', value: 0.6666},
          {text: '75%', value: 0.75},
        ],
        span_row: false,
        h_align: 'center',
        hAlignOptions: [
          {value: 'left', text: trans('left')},
          {value: 'center', text: trans('center')},
          {value: 'right', text: trans('right')},
        ],
        am_class_id: null,
        cls: null,
      }
    },
    computed: {
      serialized() {
        return {
          type: this.type,
          text: this.text,
          text2: this.text2,
          image_percent: this.image_percent,
          span_row: this.span_row,
          h_align: this.h_align,
          meta: {
            am_class_id: this.am_class_id,
          },
          after: this.after,
        }
      },
      serializedForPreview() {
        return _.assign(_.cloneDeep(this.serialized), {span_row: false})
      },
    },
    methods: {
      onShown() {
        this.text = !!this.block ? this.block.text : defaultText
        this.text2 = !!this.block ? this.block.text2 : null
        this.image_percent = this.block ? this.block.image_percent || 0.3333 : 0.3333
        this.span_row = this.block ? this.block.span_row || false : false
        this.h_align = this.block ? this.block.h_align || 'center' : 'center'
        this.am_class_id = !!this.block ? this.block.meta.am_class_id : null
        this.$nextTick(() => {
          this.visible = true
        })
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.span_row = false
        this.h_align = 'center'
        this.visible = false
        this.am_class_id = null
        this.cls = null
      },
      onChooseClass(cls) {
        this.cls = cls
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-attendance-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pageAttendanceModal = this
    },
  }
</script>